/* eslint-disable */
import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import VuePdfEmbed from "vue-pdf-embed";
import Multiselect from "@vueform/multiselect";

import QcReviewPopup from "./../TmfDocApprovals/QcReviewPopup.vue";
import customModal from "../customModal/customModal.vue";
import docversionpopup from "../docversionpopup/docversionpopup.vue";
import manageDocRecipient from "../ManageDocRecipient/ManageDocRecipient.vue";

export default {
  props: {
    referenceId: String,
    versionId: String,
  },
  components: {
    VuePdfEmbed,
    customModal,
    QcReviewPopup,
    docversionpopup,
    manageDocRecipient,
    Multiselect,
  },

  data() {
    return {
      maximized: false,
      issigned: false,
      selectedversionid:"",
      popupTitle: "",
      versiondetails: {},
      isDocLoading: true,
      isSignLoading: false,
      passversiontodocusign: "",
      showLoading: false,

      showDetailModal: false,
      selectedDetailType: "",
      selectedDetail: null,

      mainapi: `${process.env.VUE_APP_Service_URL}`,
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
      fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
      office: ["xls", "xlsx", "doc", "docx"],

      envelopeId: "",
      signingUrl:false,
      docusign: {},
      showdocsigniframe: false,
      docusigndata: [],
      docsignurl: "",
      docuSignWatchTimer: null,

      roleList: [],
      selectedRole: [],

      approvals: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyIs,
        actionType: this.selectedApprovalType,
        version: this.versionId,
        approveList: [],
        reviewList: [],
        qcList: [],
      },

      datacorrected: {
        sent: "Pending",
        created: "Awaiting",
        completed: "Signed",
      },

      review: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyId,
        version: this.versionId,
        actionType: "review",
        reviewList: [],
      },

      qcs: {
        documentId: this.referenceId,
        studyId: store.getters.getStudyId,
        version: this.versionId,
        actionType: "qc",
        qcList: [],
      },

      documentLoader: false,
      singleApproval: {
        documentId: this.referenceId,
        studyid: store.getters.getStudyId,
        version: this.versionId,
        approveList: {
          approvalType: "",
          approvalTypeID: "",
          approvedByEmail: "",
          isRequired: true,
          comments: "",
        },
      },

      list: [],
      documentUploadFields: {
        folderid: "",
        documentIdd: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
      },

      approver: {},
      documentDescription: "",
      documentVersions: [],
      assignedByUsername: "",
      approvedStatus: "",
      reviewStatus: "",
      qcStatus: "",
      status: "",
      comments: "",
      showValue: "",
      approvaldetails: "",
      loadingSingleSave: [false],
      userobject: [],
      userList: [],
      removeUser: [],
      roleIds: [],
      isRequired: [],
      isSelectedUser: [],
      isDisabled: [],
      documentValidationsError: [false, false, false, false, false, false, false],
      loadingDocUpload: false,
      loadingSaveModalBtn: false,

      format: "",
      source: "",
      officeurl: "",
      NewFile: "",
      presentPage: "",
      currentProcess: "",
      currentDocProcess: "",
      documentApprovalModal: false,
      uploadDocumentModal: false,
      showSave: false,
      ownerList: [],
      sourcePage: "",
      getApproverList: [],
      
      selectedsignorder:"",
      selectedenvelopid:"",
      approversEmails: [],
      designation: "",
      designationList: [],
      selectedrecepientemal:"",
      documentEdit: false,
      docTitle: "",
      docVersion: "",
      approvalType: "",
      canSelectApprovers: false,
      canSelectQC: false,
      canSelectReviewers: false,
      canUpload: false,
      canSelectSigners: false,
      canCompleteDocument: false,
      docusignRelayAllowedOrigin: window.location.origin,
      testiframe: false,
      updatedBy: "",
      uploadedBy: "",
      standard: "",
      currentVersion: "",
      department: "",
      owner: "",
      documentTitle: "",
      type: "",
      readMore: [false],
      checkstatusvalue: "Pending , Approved , Rejected",
      versionList: [],
      documentid: "",
      newversionforsigner: "",
      selectedApprovalType: "",
      isSigningUrlFetching: false, 
      selectedDueDate: null,
      showDocRecipient: false,
      docDetails: {},
      modalContext: "",
      qcReviewApprovalStatus: {},
      actionType: "",
      approveButtonLabel: "Approve",
      signstatus: "",
      completionStatus: "",

      // from Development branch
      loggedinUser: {},
      statuses: {
        reviewed: {
          email : "",
          status:"",
          actionTime: ""
        },
        qced: { 
          email : "",
          status:"",
          actionTime: ""
        },
        approved: { 
          email : "",
          status:"",
          actionTime: ""
        },
        signed: { 
          email : "",
          status:"",
          envelopeId:"",
          actionTime: "",
          completed: false, 
          timestamp: ""
        }
      },
      showActionPopup: false,
      actionType: "",
      actionStatus : "",
      defaultdate: "",
      designationList: [],
       readMore: []
    }
    
  },

  beforeRouteEnter(to, from, next) {
    const src = from?.name || "direct";
    localStorage.setItem("presentPage", src);
    next((vm) => {
      vm.previousRouteName = src;
    });
  },

  unmounted() {
    delete window.showAlert;
    if (this.docuSignWatchTimer) clearInterval(this.docuSignWatchTimer);
    localStorage.removeItem("presentPage");
  },

  async mounted() {
    this.selectedversionid = this.versionId;
    window.showAlert = this.showAlert.bind(this);
    this.presentPage = localStorage.getItem("presentPage") || "direct";
    this.defaultdate = localStorage.getItem("dateformat");
    if (this.presentPage === "folderDocLogin") {
      this.currentProcess = localStorage.getItem("currentdocprocess");
      if (this.currentProcess !== null && this.currentProcess !== undefined) {
        this.showValue = "Pending";
      }
    }

    if (["TmfDocReviewList", "TmfDocQcList", "etmfdoc", "etmfuserdashboard"].includes(this.presentPage)) {
      this.idtoken = store.getters.getToken;
      await this.getApprovalStatus();
    }
    console.log('setdocversion ISSS',this.referenceId)
    await this.checkqcReviewApproval("");
    await this.setfilename();
    await this.setdoc();
    await this.getVersionHistory();
    await this.approveLabel();

    await this.getTokenInfo();
    console.log("this.versiondetails",this.versiondetails);
    console.log("this.loggedinUser.email",this.loggedinUser.email);
    await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    this.readMore = this.versionList.map(() => false);
  },

  computed: {
    formatLower() {
      return (this.format || "").toLowerCase();
    },
  },

  methods: {
    maximizeorminimise(val){
      this.maximized = val;
    },
     toggleRead(index) {
      // Vue 2 requires $set for reactivity, Vue 3 does not
      this.readMore[index] = !this.readMore[index];
    },
    async tryFetch(url, options = {}) {
      try {
        await axios.get(url, {
          ...options,
          responseType: "blob",
        });
        return true;
      } catch (e) {
        return false;
      }
    },

    inferFormatFromUrl(url) {
      const ext = (url.split("?")[0].split(".").pop() || "").toLowerCase();
      return ext || "";
    },

    onImageLoad() {
      this.isDocLoading = false;
    },
    onPdfLoaded() {
      this.isDocLoading = false;
    },
    onOfficeLoad() {
      this.isDocLoading = false;
    },

    async approveLabel() {
      if (this.presentPage === "TmfDocReviewList" || this.presentPage === "TmfDocQcList") {
        this.approveButtonLabel = "Complete";
      }
    },

    async getVersionHistory() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/document/documentversion?documentId=${this.referenceId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.versionList = res.data;
          this.newversionforsigner = this.versionList[0]?.version;
        })
        .catch(() => {
          this.versionList = [];
        });
    },

    async checkqcReviewApproval(version="") {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/etmf/document/approvalreviewerqccount?id=${this.referenceId}&studyId=${store.getters.getStudyIs}&version=${version}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.qcReviewApprovalStatus = {
          approvalCount: res.data.approvalCount || 0,
          reviewerCount: res.data.reviewerCount || 0,
          qcCount: res.data.qcCount || 0,
          isConfig: res.data.isConfig || 0,
        };
      } catch (err) {
        console.error("Error fetching QC Review Approval Status:", err);
        this.qcReviewApprovalStatus = {
          approvalCount: 0,
          reviewerCount: 0,
          qcCount: 0,
          isConfig: 0,
        };
      }
    },

    uploadDocumentModalClose() {
      this.list = [];
      this.uploadDocumentModal = false;
      this.getVersionHistory();
    },

    async getStudyBasedUsers() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.entities && res.data.entities.length) {
            this.ownerList = res.data.entities.sort((a, b) => a.firstName.localeCompare(b.firstName));
          }
          this.setCurrentUser(this.ownerList);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setCurrentUser(data) {
      const idtoken = store.getters.getIdToken;
      const userEmail = jwt_decode(idtoken).email.trim();
      const userObject = data.find((item) => item.email === userEmail);
      if (userObject) {
        this.currentUser = `${userObject.firstName} ${userObject.lastName}`;
      }
    },

    async NewDocVersion() {
      try {
        this.uploadDocumentModal = true;
        this.getStudyBasedUsers();
        this.documentEdit = true;

        this.docTitle = "";
        this.docVersion = "";
        this.documentUploadFields = {
          owner: "",
          documentTitle: "",
          expiryDate: "",
          description: "",
          changesHistory: "",
          documentType: "",
        };
        this.addsigner = false;
        this.bookmarklist = [];
        this.signuserList = [];
        this.list = [];

        const idtoken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/etmf/document/getnewversiondocumentitemdetails?documentId=${this.referenceId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;
        this.docTitle = data.documentTitle || "";
        this.docVersion = data.version || "";
        this.selectedversionid = data.version?data.version:this.selectedversionid;
        this.documentUploadFields.owner = data.owner || "";
        this.documentUploadFields.documentTitle = data.documentTitle || "";
        this.documentUploadFields.expiryDate = data.expiryDate || "";
        this.documentUploadFields.description = data.description || "";
        this.documentUploadFields.changesHistory = data.changesHistory || "";
        this.documentUploadFields.documentType = data.documentType || "";
        this.bookmarklist = data.bookmarkList || [];
        this.signuserList = data.signUserList || [];
        this.addsigner = this.bookmarklist.length > 0;
        this.list = data.attachedFiles || [];
      } catch (error) {
        console.error("Error fetching new version document details:", error);
        this.$toast?.error?.("Unable to load document version details");
      }
    },

    async showAlert(message) {
      this.issigned = true;
      this.showdocsigniframe = false;
      console.log("Message from iframe:", message);
      const idtoken = store.getters.getIdToken;
      const payload = { envelopeId: this.envelopeId };
      try {
        await axios.post(`${this.baseurl}/etmf/docusign/envelopesent`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
      } catch (err) {
        console.error(err);
      }
      await this.setfilename();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },

    testiframefun() {
      this.testiframe = true;
    },

    async docuSignCreated({ envelopeId, embeddedUrl }) {
      alert("Signers added successfully,Please proceed to add bookmarks on the next screen.");
      this.envelopeId = envelopeId;
      this.docsignurl = embeddedUrl;
      this.isSignLoading = true;
      this.showdocsigniframe = true;
      this.showDocRecipient = false;
    },

    // async setfilename() {
    //   try {
    //     const idtoken = store.getters.getIdToken;
    //     const res = await axios.get(
    //       `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${this.referenceId}`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     if (res.data.docusign && res.data.docusign.recipients) {
    //       this.docusigndata = res.data.docusign.recipients;
    //     }

    //     const d = res.data.document || {};
    //     this.docDetails = d;
    //     this.NewFile = d.name || this.filename || "";
    //     this.format = d.type;

    //     if (Array.isArray(d.userPermission) && d.userPermission[0]?.permission) {
    //       const perms = d.userPermission[0].permission;
    //       this.canSelectApprovers = perms.includes("Select Approver");
    //       this.canSelectReviewers = perms.includes("Select Reviewer");
    //       this.canSelectQC = perms.includes("Select Qc");
    //       this.canUpload = perms.includes("Upload");
    //       this.canSelectSigners = perms.includes("Select Signer");
    //       this.canCompleteDocument = perms.includes("Complete Document");
    //     } else {
    //       this.canSelectApprovers =
    //         this.canSelectReviewers =
    //         this.canSelectQC =
    //         this.canUpload =
    //         this.canCompleteDocument =
    //           false;
    //     }

    //     this.issigned = !!d.isSignConfig;
    //     this.completionStatus = d.documentStatus || "";
    //     const docuSign = res.data.docusign || {};
    //     this.signstatus = docuSign.status || "";

    //     await this.getvesiondetails(this.versionId);
    //     return;
    //   } catch (e) {
    //     // fall through to file svc
    //   }

    //   try {
    //     this.NewFile = this.filename || this.NewFile || "";
    //     this.format = (this.NewFile.split(".").pop() || "").toUpperCase();
    //     await axios.get(
    //       `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.versionId}`,
    //       { responseType: "blob" }
    //     );
    //   } catch (e) {
    //     console.error("Filename/details fallback failed", e);
    //   }
    // },
    async setfilename() {
  try {
    const idtoken = store.getters.getIdToken;
    const res = await axios.get(
      `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${this.referenceId}&version=${this.selectedversionid}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    if (Array.isArray(res.data.docusign)) {
  const matched = res.data.docusign.find(d => String(d.documentVersion) === String(this.selectedversionid));
  this.envelopeId   = matched ? matched.envelopeId : null;

this.docusigndata = matched && matched.recipients ? matched.recipients : [];
this.signstatus   = matched && typeof matched.status !== "undefined" ? matched.status : "";
} else {
  this.envelopeId = null;
  this.docusigndata = [];
  this.signstatus = "";
}
    const d = res.data.document || {};
    this.docDetails = d;
    this.NewFile = d.name || this.filename || "";
    this.format = d.type;

    if (Array.isArray(d.userPermission) && d.userPermission[0]?.permission) {
      const perms = d.userPermission[0].permission;
      this.canSelectApprovers = perms.includes("Select Approver");
      this.canSelectReviewers = perms.includes("Select Reviewer");
      this.canSelectQC = perms.includes("Select Qc");
      this.canUpload = perms.includes("Upload");
      this.canSelectSigners = perms.includes("Select Signer");
      this.canCompleteDocument = perms.includes("Complete Document");
    } else {
      this.canSelectApprovers =
        this.canSelectReviewers =
        this.canSelectQC =
        this.canUpload =
        this.canCompleteDocument =
          false;
    }

    this.issigned = !!d.isSignConfig;
      this.documentDescription = d.documentDescription;
    this.completionStatus = d.documentStatus || "";

    if (Array.isArray(res.data.docusign) && res.data.docusign.length > 0) {
      const lastDocuSign = res.data.docusign[res.data.docusign.length - 1];
      this.signstatus = lastDocuSign.status || "";
    } else {
      this.signstatus = "";
    }

    await this.getvesiondetails(this.selectedversionid);
    return;
  } catch (e) {
  }

  try {
    this.NewFile = this.filename || this.NewFile || "";
    this.format = (this.NewFile.split(".").pop() || "").toUpperCase();
    await axios.get(
      `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.selectedversionid}`,
      { responseType: "blob" }
    );
  } catch (e) {
    console.error("Filename/details fallback failed", e);
  }
}
,

    async setdoc() {
      this.isDocLoading = true;

      const primary = `${this.baseurl}/etmf/document/documentfile/${this.referenceId}?version=${this.selectedversionid}`;
      const fallback = `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.selectedversionid}`;

      const canPrimary = await this.tryFetch(primary);
      this.source = canPrimary ? primary : fallback;

      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.source)}`;

      if (!this.format) this.format = this.inferFormatFromUrl(this.source).toUpperCase();
    },

    async previousPage() {
      if (this.presentPage === "folderDocLogin" || this.presentPage === "etmf") {
        this.$router.push("/etmf");
      } else {
        this.$router.go(-1);
      }
    },

    async getvesiondetails(passedVersion) {
      console.log("inside getversiondetails function.....!!!!!!");
      try {
        this.passversiontodocusign = passedVersion;
        const versions =
          this.docDetails && Array.isArray(this.docDetails.documentVersions)
            ? this.docDetails.documentVersions
            : [];

        const key = String(passedVersion == null ? "" : passedVersion).trim();

        let match = null;
        if (key) {
          match = versions.find((v) => String(v.version).trim() === key) || null;
        } else {
          match =
            versions.slice().sort((a, b) => Number(b.version) - Number(a.version))[0] || null;
        }

        this.versiondetails = match || {};
        return match;
      } catch (e) {
        console.error("getVersionDetails error:", e);
        this.versiondetails = {};
        return null;
      }
    },

    /* Document approval functionality starts*/
    openApprovalModal(Approvaltype) {
      this.selectedApprovalType = Approvaltype;
      this.documentApprovalModal = true;
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.listRoles();
    },

    async closeDocumentApprovalModal() {
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.roleList = [];
      this.designation = "";
      this.designationList = [];
      this.userList = [];
      this.documentApprovalModal = false;
      this.selectedApprovalType = "";
      this.selectedDueDate = "";
      this.showSave = false;

      await this.checkqcReviewApproval();
      await this.setfilename();
      await this.getApprovers();
      await this.getvesiondetails(this.selectedversionid);
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },

    async listRoles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/roles/search?`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data?.data?.length) {
            this.roleList = res.data.data.sort((a, b) => a.role_Name.localeCompare(b.role_Name));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onDocuSignFrameLoad() {
      this.isSignLoading = false;
    },

    async onChange(selected) {
      this.showSave = true;
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      this.userobject = [];
      this.userList = [];
      this.isSelectedUser = [];
      this.isRequired = [];

      if (Array.isArray(selected)) {
        for (let roleId of selected) {
          await this.getDesignationUser(roleId);
        }
      } else if (selected) {
        await this.getDesignationUser(selected);
      }
    },

    async getDesignationUser(role) {
  const idtoken = store.getters.getIdToken;
  await axios
    .post(
      `${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
      [`${role}`],
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data && res.data.length) {
        const mergedList = [...this.userList, ...res.data];
        this.userList = mergedList
          .filter(
            (user, index, self) =>
              index === self.findIndex((u) => u.email === user.email) 
          )
          .sort((a, b) => a.name.localeCompare(b.name));
      }

      this.isRequired = [];
      this.isSelectedUser = [];
      this.isDisabled = [];
      this.userList.forEach((user, index) => {
        this.isRequired[index] = false;
        this.isSelectedUser[index] = false;
        this.isDisabled[index] = false;
        this.loadingSingleSave[index] = false;
      });

      this.getApprovers();
    })
    .catch((err) => {
      console.log(err);
    });
},

    




    // async getDesignationUser(role) {
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .post(`${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`, [`${role}`], {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then((res) => {
    //       if (res.data && res.data.length) {
    //         this.userList = res.data.sort((a, b) => a.name.localeCompare(b.name));
    //       }
    //       this.isRequired = [];
    //       this.isSelectedUser = [];
    //       this.isDisabled = [];
    //       this.userList.forEach((user, index) => {
    //         this.isRequired[index] = false;
    //         this.isSelectedUser[index] = false;
    //         this.isDisabled[index] = false;
    //         this.loadingSingleSave[index] = false;
    //       });
    //       this.getApprovers();
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    async getApprovers() {
      this.approvals.version = this.selectedversionid;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getapprovers?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getApproverList = res.data || [];
          this.approversEmails = [];

          this.isRequired = [];
          this.isSelectedUser = [];
          this.isDisabled = [];
          this.userList.forEach((user, index) => {
            const approver =
              this.getApproverList.find(
                (a) => a.approvedByEmail === user.email || a.approvedByEmail === user.emailId
              ) || null;
            if (approver) {
              this.isRequired[index] = !!approver.isRequired;
              this.isSelectedUser[index] = true;
              this.isDisabled[index] = approver.approvedStatus === "Approved";
              this.approversEmails.push(approver.approvedByEmail);
            } else {
              this.isRequired[index] = false;
              this.isSelectedUser[index] = false;
              this.isDisabled[index] = false;
            }
          });

          this.approvals.approveList = this.getApproverList.map((a) => ({
            approvalType: a.approvalType || this.approvalType,
            approvalTypeID: a.approvalTypeID || this.designation,
            approvedByEmail: a.approvedByEmail,
            isRequired: !!a.isRequired,
            comments: a.comments || "",
          }));
        })
        .catch((err) => {
          console.log("error in multiple approve", err);
        });
    },

    selectall() {
      this.removeUser = [];
      this.approvals.approveList = [];
      this.approvals.version = this.selectedversionid;
      const checkBoxall = document.getElementById("selectAllDocumentApprovers");
      if (checkBoxall.checked === true) {
        this.userList.forEach((users, index) => {
          if (this.isDisabled[index] === true) {
            this.isDisabled[index] = true;
          } else {
            this.userobject[users.userId] = true;
            this.isSelectedUser[index] = true;
            this.isRequired[index] = false;
            this.approvals.approveList.push({
              approvalType: this.approvalType,
              approvalTypeID: this.designation,
              approvedByEmail: users.emailId || users.email,
              isRequired: false,
              comments: "",
            });
          }
        });
      } else {
        this.userobject = [];
        this.approvals.approveList = [];
        this.approvals.version = this.selectedversionid;
        this.userList.forEach((user, index) => {
          if (this.isDisabled[index] === true) {
            this.isDisabled[index] = true;
          } else {
            this.userobject[user.userId] = false;
            this.isRequired[index] = false;
            this.isSelectedUser[index] = false;
            this.removeUser.push(user.email || user.emailId);
          }
        });
      }
    },

    onDocError(e) {
      this.isDocLoading = false;
      console.error("Document load error", e);
    },

    async versionViewer(versionId, versionType, version) {
       if (this.selectedversionid === version) return;
      this.selectedversionid = version;
      this.isDocLoading = true;
      this.format = (versionType || "").toUpperCase();

      const primary = `${this.baseurl}/etmf/document/documentfile/${this.referenceId}?version=${version}`;
      const fallback = `${this.fileuploadurl}/file/${this.referenceId}?versionid=${version}`;

      const canPrimary = await this.tryFetch(primary);
      this.source = canPrimary ? primary : fallback;
      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.source)}`;
      // await this.getvesiondetails(version);
      await this.checkqcReviewApproval(version);
      
      
      await this.setfilename();
      await this.getApprovers();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
      
    },

    async singleSaveApprover(user, index) {
      if (this.isDisabled[index] === true) {
        console.warn("disabled");
        return;
      }
      if (!this.isSelectedUser.some((val) => val) && !this.removeUser.length) {
        alert("Please enter the user");
        return;
      }

      if (this.isSelectedUser[index] === false) {
        const idtoken = store.getters.getIdToken;
        this.loadingSingleSave[index] = true;
        await axios
          .put(
            `${this.baseurl}/etmf/document/removeapprover?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}&approverType=${this.selectedApprovalType}`,
            [user.email || user.emailId],
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            this.loadingSingleSave[index] = false;
            alert(this.$t("navigations.approver removed successfully"));
            this.removeUser = [];
          })
          .catch((err) => {
            this.loadingSingleSave[index] = false;
            console.log("error in remove approver", err);
          });
        return;
      }

      if (this.isSelectedUser[index] === true) {
        const idtoken = store.getters.getIdToken;
        this.loadingSingleSave[index] = true;

        const payload = {
          documentId: this.referenceId,
          studyId: store.getters.getStudyIs,
          version: this.selectedversionid,
          actionType: this.selectedApprovalType,
        };

        if (this.selectedApprovalType === "approval") {
          payload.approveList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            approvedByEmail: user.email || user.emailId,
            isRequired: this.isRequired[index],
            comments: "",
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        } else if (this.selectedApprovalType === "review") {
          payload.reviewList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            reviewedByEmail: user.email || user.emailId,
            reviewedByUsername: user.username || user.name,
            isRequired: this.isRequired[index],
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        } else if (this.selectedApprovalType === "qc") {
          payload.qcList = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            qcByEmail: user.email || user.emailId,
            qcByUsername: user.username || user.name,
            isRequired: this.isRequired[index],
            dueDate: this.selectedDueDate ? this.selectedDueDate : null,
          };
        }

        await axios
          .post(`${this.baseurl}/etmf/document/singlesaveapprover`, payload, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            this.loadingSingleSave[index] = false;
            if (this.selectedApprovalType === "approval") {
              alert("Assigned approver successfully");
            } else if (this.selectedApprovalType === "review") {
              alert("Assigned reviewer successfully");
            } else if (this.selectedApprovalType === "qc") {
              alert("Assigned QC successfully");
            }
            this.checkqcReviewApproval("");
            this.setfilename();
          })
          .catch((err) => {
            console.log(`error in single ${this.selectedApprovalType}`, err);
            this.loadingSingleSave[index] = false;
          });
      } else {
        alert(this.$t("navigations.please select a user"));
      }
    },

    async removefile(index) {
      this.list.splice(index, 1);
    },

    async loadfile() {
      let fileload = document.getElementById("InPutFile");
      fileload.click();
    },

    async multipleSaveApprover() {
      const idtoken = store.getters.getIdToken;

      if (!this.isSelectedUser.some((val) => val) && this.removeUser.length === 0) {
        alert("Please select users");
        return;
      }

      if (this.isSelectedUser.every((val) => val === false) && this.removeUser.length > 0) {
        try {
          await axios.put(
            `${this.baseurl}/etmf/document/removeapprover?documentId=${this.referenceId}&versionNumber=${this.selectedversionid}&approverType=${this.selectedApprovalType}`,
            this.removeUser,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.approver removed successfully"));
          this.removeUser = [];
          this.closeDocumentApprovalModal();
          return;
        } catch (err) {
          console.error("Error in multiple remove approver", err);
          return;
        }
      }

      const payload = {
        documentId: this.referenceId,
        studyId: store.getters.getStudyIs,
        version: this.selectedversionid,
        actionType: this.selectedApprovalType,
        approveList: [],
        reviewList: [],
        qcList: [],
      };

      this.userList.forEach((user, index) => {
        if (this.isSelectedUser[index]) {
          const roleId = user.roleId ? String(user.roleId) : this.designation;

          if (this.selectedApprovalType === "approval") {
            payload.approveList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              approvedByEmail: user.email || user.emailId,
              isRequired: !!this.isRequired[index],
              comments: "",
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          } else if (this.selectedApprovalType === "review") {
            payload.reviewList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              reviewedByEmail: user.email || user.emailId,
              reviewedByUsername: user.username || user.name,
              isRequired: !!this.isRequired[index],
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          } else if (this.selectedApprovalType === "qc") {
            payload.qcList.push({
              approvalType: this.approvalType,
              approvalTypeID: roleId,
              qcByEmail: user.email || user.emailId,
              qcByUsername: user.username || user.name,
              isRequired: !!this.isRequired[index],
              dueDate: this.selectedDueDate ? this.selectedDueDate : null,
            });
          }
        }
      });

      try {
        await axios.post(`${this.baseurl}/etmf/document/multiplesaveapprover`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        if (this.selectedApprovalType === "approval") {
          alert("Assigned approvers successfully");
        } else if (this.selectedApprovalType === "review") {
          alert("Assigned reviewers successfully");
        } else if (this.selectedApprovalType === "qc") {
          alert("Assigned QCs successfully");
        }
        this.closeDocumentApprovalModal();
      } catch (err) {
        console.error(`Error in multiple ${this.selectedApprovalType}`, err);
      }
    },

    async addApprover(user, index) {
      if (this.isSelectedUser[index] === true) {
        this.removeUser.push(this.userList[index].email);
        const approver = {
          approvalType: this.approvalType,
          approvalTypeID: this.designation,
          approvedByEmail: user.email,
          isRequired: this.isRequired[index],
          comments: "",
        };
        this.approvals.approveList.push(approver);
        if (this.removeUser.some((data) => data === user.email)) {
          this.removeUser.splice(this.removeUser.indexOf(user.email), 1);
        }
      } else {
        this.isRequired[index] = false;
        this.removeUser.push(this.userList[index].email);
        const removeUser = this.userList[index].email;
        this.approvals.approveList.forEach((approver) => {
          if (approver.approvedByEmail === removeUser) {
            this.approvals.approveList.splice(this.approvals.approveList.indexOf(approver), 1);
          }
        });
      }
    },

    async addRequiredApprover(user, index) {
      if (this.isRequired[index] === true) {
        this.isSelectedUser[index] = true;
        if (!this.approvals.approveList.some((data) => data.approvedByEmail === user.email)) {
          const approver = {
            approvalType: this.approvalType,
            approvalTypeID: this.designation,
            approvedByEmail: user.email,
            isRequired: this.isRequired[index],
            comments: "",
          };
          this.approvals.approveList.push(approver);
        }

        if (this.removeUser.some((data) => data === user.email)) {
          this.removeUser.splice(this.removeUser.indexOf(user.email), 1);
        }
      }
    },

    async ApprovalStatus(value) {
      if (this.presentPage === "etmfdoc") {
        this.status = value ? "Approved" : "Rejected";
      } else if (this.presentPage === "TmfDocReviewList" || this.presentPage === "TmfDocQcList") {
        this.status = value ? "Completed" : "Rejected";
      }

      if (value) {
        if (confirm("Are you sure you want to proceed?")) {
          await this.approvalsave(value);
          this.closeDocumentApprovalModal();
        }
      } else {
        if (confirm("Are you sure you want to reject the document?")) {
          await this.approvalsave(value);
          this.closeDocumentApprovalModal();
        }
      }
    },

    async approvalsave(value) {
      const idtoken = store.getters.getIdToken;

      if (this.presentPage === "etmfdoc") {
        this.actionType = "approval";
      }
      if (this.presentPage === "TmfDocReviewList") {
        this.actionType = "review";
      }
      if (this.presentPage === "TmfDocQcList") {
        this.actionType = "qc";
      }

      if (this.presentPage === "folderDocLogin") {
        const actiontypepassed = localStorage.getItem("passedactiontype");
        if (actiontypepassed === "DocApprove") this.actionType = "approval";
        else if (actiontypepassed === "DocReview") this.actionType = "review";
        else if (actiontypepassed === "DocQC") this.actionType = "qc";
        else this.actionType = "approval";
      }

      await axios
        .put(
          `${this.baseurl}/etmf/document/approvereject`,
          {
            documentId: this.referenceId,
            version: this.selectedversionid,
            approvalStatus: this.status,
            comments: this.comments,
            actionType: this.actionType,
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          if (value === true) {
            if (this.actionType === "approval") {
              alert("The document approved successfully.");
            } else if (this.actionType === "review") {
              alert("The document review completed successfully.");
            } else if (this.actionType === "qc") {
              alert("The document QC completed successfully.");
            }
          } else {
            alert("The document rejected successfully.");
          }
          this.getApprovalStatus();
          this.checkqcReviewApproval("");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getApprovalStatus() {
      const idtoken = store.getters.getIdToken;
      if (this.presentPage === "etmfdoc" || this.presentPage === "etmfuserdashboard") {
        this.actionType = "approval";
      }
      if (this.presentPage === "TmfDocReviewList") {
        this.actionType = "review";
      }
      if (this.presentPage === "TmfDocQcList") {
        this.actionType = "qc";
      }
      await axios
        .get(
          `${this.baseurl}/etmf/document/approvalbyid?documentId=${this.referenceId}&version=${this.selectedversionid}&actionType=${this.actionType}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.approvaldetails = res.data;
          this.showValue = this.approvaldetails.approvedStatus;
        });
    },
    /* Document approval functionality ends*/

    async openDocRecipientModal() {
      this.showDocRecipient = true;
    },
    async closeRecipientModal() {
      this.showDocRecipient = false;
    },

    async CompleteDocument(status) {
      const idtoken = store.getters.getIdToken;
      if (confirm("Are you sure you want to complete the document?")) {
        await axios
          .put(
            `${this.baseurl}/etmf/document/changedocumentstatus?docId=${this.referenceId}&status=${status}&version=${this.selectedversionid}`,
            {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            alert("The document completed successfully.");
            this.getApprovalStatus();
            this.checkqcReviewApproval("");
            this.setfilename();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    async getTokenInfo() {
      this.loggedinUser = jwt_decode(store.getters.getIdToken);
    },

    async setActionBtnVisiblity(docDetails, userEmail) {
      console.log("docdetails isss !!!!!!",docDetails);
        const d = docDetails || {};

          if (Array.isArray(d.approval)&& d.approval.length > 0) {
             console.log("inside approval array...", d.approval);
            const approval = d.approval.find(a => a.approvedByEmail === userEmail);
            if (approval) {
              this.statuses.approved.email = approval.approvedByEmail;
              this.statuses.approved.status = approval.approvedStatus;
              this.statuses.approved.actionTime = this.filter(approval.approvedDatetime);
            }
          }
          else{
            
         this.statuses.approved= { 
          "email" : "",
          "status":"",
          "actionTime": ""
        }
          }
        if (Array.isArray(docDetails.qc)&& docDetails.qc.length > 0) {
          console.log("inside qc array...", docDetails.qc);
            const qc = docDetails.qc.find(q => q.qcByEmail === userEmail);
            if (qc) {
                this.statuses.qced.email = qc.qcByEmail;
                this.statuses.qced.status = qc.qcStatus;
                this.statuses.qced.actionTime = this.filter(qc.qcCompletedDatetime);
                
            }
        }
        else{
      
        this.statuses.qced= { 
          "email" : "",
          "status":"",
          "actionTime": ""
        }
        
        }
        if (Array.isArray(docDetails.reviewer)&& docDetails.reviewer.length > 0) {
          console.log("inside reviewer array...", docDetails.reviewer);
        const reviewer = docDetails.reviewer.find(r => r.reviewedByEmail === userEmail);
        if (reviewer) {
            this.statuses.reviewed.email = reviewer.reviewedByEmail;
            this.statuses.reviewed.status = reviewer.reviewedStatus;
            this.statuses.reviewed.actionTime = this.filter(reviewer.reviewedDatetime);
        }
    }
    else{
       this.statuses.reviewed= {
          "email" : "",
          "status":"",
          "actionTime": ""
        }
       
    }

    if (Array.isArray(this.docusigndata ) && this.docusigndata.length > 0) {
       console.log("inside docusigndata array...", this.docusigndata);
        const signed = this.docusigndata.find(s => s.recipientEmail === userEmail);
        if (signed) {
            this.statuses.signed.email = signed.recipientEmail;
            this.statuses.signed.status = signed.recipientStatus;
            this.statuses.signed.recipientSignOrder = signed.recipientSignOrder; 
        }
    }
    else{
      this.statuses.signed = { 
          "email" : "",
          "status":"",
          "envelopeId":"",
          "actionTime": "",
          "completed": false, 
          "timestamp": ""
        }
    }
    },

    completeProcess(processName) {
      if (!this.statuses[processName].completed) {
        const now = new Date();
        const formattedTime = now.toLocaleString();
        this.statuses[processName].completed = true;
        this.statuses[processName].timestamp = formattedTime;
         this.$router.push({ name: 'signerslist' });
      }
    },
    async gotodocumentsign(recipientEmail, recipientSignOrder) {
      this.redirectpath = "documentview/" + this.referenceId + "/" + this.selectedversionid;
      store.dispatch('setSigningFrom', this.redirectpath)
      console.log("Navigating to document sign with:", this.envelopeId, recipientEmail, recipientSignOrder);
  if (!this.statuses.signed.completed) {
    const now = new Date();
    const formattedTime = now.toLocaleString();
    // this.$set(this.statuses.signed, "completed", true);
    this.statuses.signed.timestamp = formattedTime;
  }

  // then navigate
  this.$router.push(`/signfrompopup/${this.envelopeId}/${recipientEmail}/${recipientSignOrder}`);
  await this.setfilename();
},



    async ActionClicked(actionType){
        this.showActionPopup = true;
        this.actionType = actionType;
        if(actionType == "approval"){
          this.popupTitle = "Approve";
        }
        if(actionType == "qc"){
          this.popupTitle = "QC";
        }
        if(actionType == "review"){
          this.popupTitle = "Review";
        }

        if(actionType == "review"){
          if(this.statuses.approved.status != 'Pending'){
            this.actionStatus = this.statuses.approved.status;
          }
        }
    },
    filter(v) {
  if (!v) return "";
  const fmt = this.defaultdate || "YYYY-MM-DD";
  return moment(v).format(fmt);
},
    async closeQCReviewModal(){
      this.showActionPopup =  false;
      await this.setfilename();
      await this.setActionBtnVisiblity(this.versiondetails, this.loggedinUser.email);
    },
    openDetailPopup(type, data) {
      this.showDetailPopup = true;
      this.detailPopupType = type;
      this.detailPopupData = data;
    },
     openApprovalDetailModal(item) {
    this.selectedDetailType = "approval";
    this.selectedDetail = {
      status: item.approvedStatus,
      comment: item.comments,
      date: this.formatDateTime(item.approvedDatetime),
    };
    this.showDetailModal = true;
  },
  openReviewerDetailModal(item) {
    this.selectedDetailType = "review";
    this.selectedDetail = {
      status: item.reviewedStatus,
      comment: item.comments,
      date: this.formatDateTime(item.reviewedDatetime),
    };
    this.showDetailModal = true;
  },
  openQcDetailModal(item) {
    this.selectedDetailType = "qc";
    this.selectedDetail = {
      status: item.qcStatus,
      comment: item.comments,
      date: this.formatDateTime(item.qcCompletedDatetime),
    };
    this.showDetailModal = true;
  },
  closeDetailModal() {
    this.showDetailModal = false;
    this.selectedDetailType = "";
    this.selectedDetail = null;

  },
    formatDateTime(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date)) {
      console.error("Invalid date");
      return "";
    }

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year} | ${hours}:${minutes}:${seconds}`;
  }

}
};
